import { safeDefine } from "../../registration/safe-define.js";
import { MinimalLiveAudioSkinElement } from "../../presets/live-audio/minimal-skin.js";
import "../../internal/skins/minimal-live-audio/register.js";
//#region src/define/live-audio/minimal-skin.ts
safeDefine(MinimalLiveAudioSkinElement);
//#endregion
